import { render } from "./Kingdoms.vue?vue&type=template&id=2bb093e9"
import script from "./Kingdoms.vue?vue&type=script&lang=js"
export * from "./Kingdoms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/Kingdoms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bb093e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bb093e9', __exports__)) {
    api.reload('2bb093e9', __exports__)
  }
  
  module.hot.accept("./Kingdoms.vue?vue&type=template&id=2bb093e9", () => {
    api.rerender('2bb093e9', render)
  })

}


export default __exports__